import { useCallback, useEffect, useRef } from 'react';

import { useDocumentVisibilityDetection } from './useDocumentVisibilityDetection';

export type WindowFocusRefreshControls = {
  deactivate: () => void;
};

export const useWindowFocusRefresh = (
  refresh: (controls: WindowFocusRefreshControls) => void | Promise<void>,
): WindowFocusRefreshControls & { activate: () => void } => {
  const activeRef = useRef(false);
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  const deactivate = useCallback(() => {
    activeRef.current = false;
  }, []);

  const activate = useCallback(() => {
    activeRef.current = true;
  }, []);

  useDocumentVisibilityDetection(
    useCallback(
      (isVisible: boolean) => {
        if (!isVisible || !activeRef.current) {
          return;
        }
        void Promise.resolve(refreshRef.current({ deactivate })).catch(
          () => undefined,
        );
      },
      [deactivate],
    ),
  );

  useEffect(
    () => () => {
      activeRef.current = false;
    },
    [],
  );

  return { activate, deactivate };
};
